import React, { FC } from "react";
import classNames from "classnames";
import { Button } from "../Button";
import Icon from "../Icon";

type Props = {
  label: string;
  value?: string;
  error?: string;
  hint?: string;
  onClick: () => void;
  className?: string;
  dataTest?: string;
};

export const FormCard: FC<Props> = ({
  label,
  value,
  error,
  hint,
  onClick,
  className,
  dataTest,
}) => {
  return (
    <div className="flex flex-col gap-1" data-test={dataTest}>
      <div
        className={classNames(
          "flex flex-row justify-between bg-white border border-slate-600 rounded-xl py-3 px-4 h-[72px]",
          className
        )}
      >
        <div className="flex flex-col gap-1 justify-center">
          <div
            className="uppercase theme-caption"
            data-test={`${dataTest}-label`}
          >
            {label}
          </div>

          {value && <div data-test={`${dataTest}-value`}>{value}</div>}
        </div>

        <div>
          <Button
            variant={value ? Button.variant.SECONDARY : Button.variant.PRIMARY}
            onClick={onClick}
            icon
            dataTest={`${dataTest}-button`}
          >
            <Icon icon={value ? "Edit" : "Add"} size={24} disableFill />
          </Button>
        </div>
      </div>

      {!error && hint && (
        <div
          className="px-4 text-xs theme-text-secondary"
          data-test={`${dataTest}-hint`}
        >
          {hint}
        </div>
      )}

      {error && (
        <div
          className="px-4 text-xs theme-text-error"
          data-test={`${dataTest}-error`}
        >
          {error}
        </div>
      )}
    </div>
  );
};
